import { Button, Cell, FormControl, Grid, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { TextField } from 'components/form'
import { Form, FormRenderProps } from 'components/form/final-form/Form'
import React, { useState } from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, required } from 'util/validation'

import { CancelarSolicitacaoEnvio } from './CancelarSolicitacaoEnvio'

export interface SolicitacaoEnvioFormProps {
  conexaoInternet: boolean
}

export interface SolicitacaoEnvioModel {
  nomeInstalacao: string
  enderecoInstalacao: string
}

export const validator = createValidator<SolicitacaoEnvioModel>({
  nomeInstalacao: [required, maxLength(255)],
  enderecoInstalacao: [required, maxLength(255)],
})

type EstadoComponenteEnvio = 'ENVIO_SOLICITADO' | 'SOLICITAR_ENVIO'

export const SolicitacaoEnvioForm = (props: SolicitacaoEnvioFormProps) => {
  const path = metaPath<SolicitacaoEnvioModel>()
  const { conexaoInternet } = props
  const alert = useAlert()
  const [componentState, setComponentState] = useState<EstadoComponenteEnvio>()
  const onSubmit = () => {
    if (!conexaoInternet) {
      alert(
        'warning',
        'Não é possível solicitar a chave para envio sem conexão com a internet. Habilite a conexão ou tente novamente mais tarde.'
      )
    } else {
      setComponentState('SOLICITAR_ENVIO')
    }
  }

  const renderForm = (formProps: FormRenderProps<SolicitacaoEnvioModel>) => {
    return (
      <VFlow>
        <Grid gap={1}>
          <Cell size={5}>
            <h4>1. Solicitação de envio</h4>
          </Cell>
          <Cell size={7} />
          <Cell size={5}>
            <TextField
              label='Nome da minha instalação'
              required
              name={path.nomeInstalacao}
              maxLength={255}
              placeholder='Ex.: São Paulo, UBS da Trindade'
            />
          </Cell>
          <Cell size={7} />
          <Cell size={4}>
            <TextField label='Link da instalação destino' required name={path.enderecoInstalacao} maxLength={255} />
          </Cell>
          <Cell size={6}>
            <FormControl label={<span>&nbsp;</span>}>
              <Button size='small' kind='primary' onClick={formProps.handleSubmit}>
                Solicitar
              </Button>
            </FormControl>
          </Cell>
          {componentState === 'SOLICITAR_ENVIO' && (
            <Cell size={6}>
              <CancelarSolicitacaoEnvio />
            </Cell>
          )}
        </Grid>
      </VFlow>
    )
  }
  return <Form<SolicitacaoEnvioModel> onSubmit={onSubmit} render={renderForm} validate={validator} {...props} />
}
